import DashboardContainer from "@legacy/dashboard/DashboardContainer"

import { faIcon } from "@utils/faIcon"

import { TopBar } from "@organisms"

import { AppFrame } from "@templates"

export default function Dashboard() {
    return (
        <AppFrame.Root>
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageTitle label="Home" icon={faIcon({ name: "house", style: "solid" })} />
                    </TopBar.TopBarHeaderStart>
                </TopBar.Header>
            </TopBar.Root>
            <AppFrame.PageContent>
                <DashboardContainer />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
